import styled from 'styled-components'
import { space } from 'styled-system'
import { COLOR_INTENT, SPACE } from 'Theme'

export const StyledArrowButton = styled.button.attrs({
  type: 'button',
})`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${SPACE.PX_4} 0;

  &[disabled] > svg > path {
    fill: ${COLOR_INTENT.GRAY_20};
  }

  ${({ isVisible }) => !isVisible && `display: none;`}

  ${space}
`
